import React, { useMemo, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Header.css';
import brandlogo from '../images/WhatsApp Image 2026-05-17 at 11.51.42 AM.jpeg';
import dynastyLogo from '../images/dynasty-logo.png';

const categories = [
  { slug: 'tomato', name: 'Tomato', icon: '🍅' },
  { slug: 'chilli', name: 'Chilli', icon: '🌶️' },
  { slug: 'brinjal', name: 'Brinjal', icon: '🍆' },
  { slug: 'watermelon', name: 'Watermelon', icon: '🍉' },
  { slug: 'muskmelon', name: 'Muskmelon', icon: '🍈' },
  { slug: 'bhendi', name: 'Bhendi', icon: '🌿' },
  { slug: 'pumpkin', name: 'Pumpkin', icon: '🎃' },
  { slug: 'cucumber', name: 'Cucumber', icon: '🥒' },
  { slug: 'ridgegourd', name: 'Ridge Gourd', icon: '🥬' },
  { slug: 'bottlegourd', name: 'Bottle Gourd', icon: '🧴' },
  { slug: 'bittergourd', name: 'Bitter Gourd', icon: '🥬' },
  { slug: 'spongegourd', name: 'Sponge Gourd', icon: '🧽' },
  { slug: 'cabbage', name: 'Cabbage', icon: '🥬' },
  { slug: 'onion', name: 'Onion', icon: '🧅' },
  { slug: 'radish', name: 'Radish', icon: '🥕' },
  { slug: 'sweetcorn', name: 'Sweet Corn', icon: '🌽' },
  { slug: 'carrot', name: 'Carrot', icon: '🥕' },
  { slug: 'capsicum', name: 'Capsicum', icon: '🫑' },
  { slug: 'dolichos', name: 'Dolichos', icon: '🫛' },
  { slug: 'yardlongbean', name: 'Yardlong Bean', icon: '🫛' },
  { slug: 'frenchbeans', name: 'French Beans', icon: '🫘' },
  { slug: 'polebeans', name: 'Pole Beans', icon: '🫘' },
  { slug: 'clusterbeans', name: 'Cluster Beans', icon: '🫘' },
  { slug: 'marigold', name: 'Marigold', icon: '🌼' },
  { slug: 'papaya', name: 'Papaya', icon: '🧡' },
  { slug: 'ashgourd', name: 'Ash Gourd', icon: '🥒' },
  { slug: 'coriander', name: 'Coriander', icon: '🌿' },
  { slug: 'palak', name: 'Palak', icon: '🥬' },
];

const Header = () => {
  const location = useLocation();
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
  const [desktopGalleryOpen, setDesktopGalleryOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const [mobileGalleryOpen, setMobileGalleryOpen] = useState(false);

  const isGalleryRoute = location.pathname.startsWith('/gallery');

  const navItems = useMemo(
    () => [
      { to: '/', label: 'Home', end: true },
      { to: '/about', label: 'About Us' },
      { to: '/products', label: 'Products' },
      { to: '/gallery', label: 'Gallery' },
      { to: '/contact', label: 'Contact Us' },
    ],
    []
  );

  const sortedCategories = useMemo(() => [...categories].sort((a, b) => a.name.localeCompare(b.name)), []);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMobileProductsOpen(false);
    setMobileGalleryOpen(false);
  };

  const handleDesktopAreaLeave = () => {
    setDesktopProductsOpen(false);
    setDesktopGalleryOpen(false);
  };

  return (
    <header className="header">
      <div className="header__bar" onMouseLeave={handleDesktopAreaLeave}>
        <div className="header__inner">
          <Link to="/" className="header__brand" aria-label="Dynasty Agri Seeds home" onClick={closeMobileMenu}>
            <img className="header__brand-logo" src={brandlogo} alt="Dynasty Agri Seeds" />
            <img className="header__brand-secondary-logo" src={dynastyLogo} alt="Dynasty logo" />
          </Link>

          <nav className="header__nav" aria-label="Primary">
            <NavLink to="/" end className={({ isActive }) => `header__link${isActive ? ' active' : ''}`}>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) => `header__link${isActive ? ' active' : ''}`}>
              About Us
            </NavLink>
            <NavLink
              to="/products"
              className={({ isActive }) => `header__link header__products-link${isActive ? ' active' : ''}`}
              onMouseEnter={() => setDesktopProductsOpen(true)}
            >
              Products <span className="header__caret">▾</span>
            </NavLink>
            <div className="header__dropdown-wrap">
              <button
                type="button"
                className={`header__link header__dropdown-trigger${isGalleryRoute ? ' active' : ''}`}
                onClick={() => {
                  setDesktopGalleryOpen((prev) => !prev);
                  setDesktopProductsOpen(false);
                }}
              >
                Gallery <span className="header__caret">▾</span>
              </button>

              {desktopGalleryOpen && (
                <div className="header__simple-dropdown">
                  <Link to="/gallery/photos" className="header__simple-dropdown-link" onClick={() => setDesktopGalleryOpen(false)}>
                    Photos
                  </Link>
                  <Link to="/gallery/videos" className="header__simple-dropdown-link" onClick={() => setDesktopGalleryOpen(false)}>
                    Videos
                  </Link>
                </div>
              )}
            </div>
            <NavLink to="/contact" className={({ isActive }) => `header__link${isActive ? ' active' : ''}`}>
              Contact Us
            </NavLink>
          </nav>

          <button
            type="button"
            className="header__toggle"
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMobileMenuOpen((prev) => !prev)}
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {desktopProductsOpen && (
          <div className="header__mega" onMouseEnter={() => setDesktopProductsOpen(true)}>
            <div className="header__mega-grid">
              {sortedCategories.map((category) => (
                <Link
                  key={category.slug}
                  to={`/products/${category.slug}`}
                  className="header__mega-card"
                  onClick={() => setDesktopProductsOpen(false)}
                >
                  <span>{category.icon}</span>
                  <h4>{category.name}</h4>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>

      {mobileMenuOpen && (
        <div className="header__mobile-menu">
          {navItems.map((item) => {
            if (item.to === '/products') {
              return (
                <div key={item.to} className="header__mobile-products-block">
                  <button
                    type="button"
                    className="header__mobile-link header__mobile-products-toggle"
                    onClick={() => setMobileProductsOpen((prev) => !prev)}
                  >
                    Products <span className={`header__caret${mobileProductsOpen ? ' open' : ''}`}>▾</span>
                  </button>

                  {mobileProductsOpen && (
                    <div className="header__mobile-submenu">
                      <Link to="/products" className="header__mobile-sublink" onClick={closeMobileMenu}>
                        <span>📦</span>
                        <span>All Products</span>
                      </Link>

                      {sortedCategories.map((category) => (
                        <Link
                          key={category.slug}
                          to={`/products/${category.slug}`}
                          className="header__mobile-sublink"
                          onClick={closeMobileMenu}
                        >
                          <span>{category.icon}</span>
                          <span>{category.name}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            if (item.to === '/gallery') {
              return (
                <div key={item.to} className="header__mobile-products-block">
                  <button
                    type="button"
                    className="header__mobile-link header__mobile-products-toggle"
                    onClick={() => setMobileGalleryOpen((prev) => !prev)}
                  >
                    Gallery <span className={`header__caret${mobileGalleryOpen ? ' open' : ''}`}>▾</span>
                  </button>

                  {mobileGalleryOpen && (
                    <div className="header__mobile-submenu">
                      <Link to="/gallery/photos" className="header__mobile-sublink" onClick={closeMobileMenu}>
                        <span>🖼️</span>
                        <span>Photos</span>
                      </Link>
                      <Link to="/gallery/videos" className="header__mobile-sublink" onClick={closeMobileMenu}>
                        <span>▶️</span>
                        <span>Videos</span>
                      </Link>
                    </div>
                  )}
                </div>
              );
            }

            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => `header__mobile-link${isActive ? ' active' : ''}`}
                onClick={closeMobileMenu}
              >
                {item.label}
              </NavLink>
            );
          })}
        </div>
      )}
    </header>
  );
};

export default Header;
